import set from 'lodash/set';
import _isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import isEmail from 'validator/lib/isEmail';
import isInt from 'validator/lib/isInt';
import isFloat from 'validator/lib/isFloat';
import isIn from 'validator/lib/isIn';
import isURL from 'validator/lib/isURL';

const isEmpty = value => value === undefined || value === null || value === '';
const join = rules => (value, data) =>
  rules.map(rule => rule(value, data)).filter(error => !!error)[0];

export const email = value => {
  if (Array.isArray(value)) {
    let hasError = false;
    value.forEach(v => {
      hasError = !hasError && !isEmpty(v) && !isEmail(v) && 'Invalid email address';
    });

    return hasError;
  }
  return !isEmpty(value) && !isEmail(value) && 'Invalid email address';
};

export const url = value =>
  !isEmpty(value) &&
  !isURL(value, {
    protocols: ['https'],
    require_protocol: true,
    require_valid_protocol: true,
  }) &&
  value.indexOf('{envslug}') === -1 &&
  'Invalid URL. Must start with https';

export const required = value => isEmpty(value) && 'Cannot be blank';

export const minLength = min => value =>
  !isEmpty(value) && value.length < min && `Must be at least ${min} characters`;

export const minSize = min => value =>
  !isEmpty(value) && parseInt(value, 10) < min && `Cannot be less than ${min}`;

export const maxSize = max => value =>
  !isEmpty(value) && parseInt(value, 10) > max && `Cannot be more than ${max}`;

export const maxLength = max => value =>
  !isEmpty(value) && value.length > max && `Must be no more than ${max} characters`;

export const maxArrayLength = max => value =>
  !isEmpty(value) &&
  Array.isArray(value) &&
  value.length > max &&
  `Must have no more than ${max} selection`;

export const integer = value => {
  try {
    return !isInt(value) && 'Must be an integer';
  } catch (e) {
    return 'Must be an integer';
  }
};
export const float = value => !isFloat(value) && 'Must be a number';

export const oneOf = values => value =>
  !isIn(value, values) && `Must be one of: ${values.join(', ')}`;

export const match = field => (value, data) => data && value !== data[field] && 'Must match';

const getErrors = (keyData, rules, key, data) => {
  let returnKeyData = keyData;

  if (typeof returnKeyData === 'number') {
    returnKeyData = `${returnKeyData}`;
  }

  if (returnKeyData === undefined || returnKeyData === null) {
    returnKeyData = '';
  }

  const rule = join([].concat(rules[key]));

  return rule(returnKeyData, data);
};

export const createValidator = rules => (data = {}) => {
  const errors = {};
  Object.keys(rules).forEach(key => {
    const keyData = data[key];

    // Normal arrays should not pass this check
    // But arrays of objects should pass

    // keyData can be an array but have typeof object, so we have to check both
    if (
      !_isEmpty(keyData) &&
      ((Array.isArray(keyData) && typeof keyData[0] === 'object') ||
        (typeof keyData === 'object' && !Array.isArray(keyData)))
    ) {
      // Loop each rule on each key
      forEach(keyData, (d, i) => {
        set(errors, [key, i], getErrors(d, rules, key, data));
      });
    } else {
      errors[key] = getErrors(keyData, rules, key, data);
    }
  });

  return errors;
};
